(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pittie-launch-hero"] && !Shopify.designMode) return;
  try {
    
  const pittieCountdowns = document.querySelectorAll('[data-pittie-countdown]');
  const pittiePad = (value) => String(value).padStart(2, '0');
  const pittieUpdateCountdown = (countdown) => {
    const launchTime = new Date(countdown.dataset.pittieCountdown).getTime();
    const distance = Math.max(0, launchTime - Date.now());
    countdown.querySelector('[data-days]').textContent = pittiePad(Math.floor(distance / 86400000));
    countdown.querySelector('[data-hours]').textContent = pittiePad(Math.floor((distance % 86400000) / 3600000));
    countdown.querySelector('[data-minutes]').textContent = pittiePad(Math.floor((distance % 3600000) / 60000));
    countdown.querySelector('[data-seconds]').textContent = pittiePad(Math.floor((distance % 60000) / 1000));
  };
  pittieCountdowns.forEach((countdown) => {
    pittieUpdateCountdown(countdown);
    window.setInterval(() => pittieUpdateCountdown(countdown), 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  const normalizeKey = (value) => value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const mainImage = root.querySelector('[data-main-product-image]');
    const thumbnails = [...root.querySelectorAll('[data-gallery-key]')];
    const variantData = document.querySelector('[data-product-variants]');
    const variants = variantData ? JSON.parse(variantData.textContent) : [];
    const selectors = [...root.querySelectorAll('[data-option-position]')];
    const variantId = root.querySelector('[data-variant-id]');
    const addButton = root.querySelector('[data-add-to-cart]');

    const selectThumbnail = (thumb) => {
      if (!thumb || !mainImage) return;
      mainImage.style.opacity = '0.45';
      mainImage.src = thumb.dataset.gallerySrc;
      mainImage.alt = thumb.dataset.galleryAlt;
      window.setTimeout(() => { mainImage.style.opacity = '1'; }, 90);
      thumbnails.forEach((item) => {
        const active = item === thumb;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    thumbnails.forEach((thumb) => thumb.addEventListener('click', () => selectThumbnail(thumb)));

    const updateVariant = () => {
      const choices = selectors.map((fieldset) => {
        const checked = fieldset.querySelector('input:checked');
        const label = fieldset.querySelector('[data-selected-option-label]');
        if (checked && label) label.textContent = checked.value;
        return checked ? checked.value : '';
      });
      const selected = variants.find((variant) => variant.options.every((option, index) => option === choices[index]));
      if (selected && variantId) variantId.value = selected.id;
      if (selected && addButton) {
        addButton.disabled = !selected.available;
        addButton.textContent = selected.available ? 'Add to bag' : 'Sold out';
      }

      const color = choices[0] || '';
      const logo = choices.length > 1 && selectors[1]?.querySelector('legend span')?.textContent.trim() === 'Logo' ? choices[1] : '';
      const galleryKey = normalizeKey(logo ? `${color} ${logo}` : color);
      const matchingThumb = selected?.featured_media
        ? thumbnails.find((thumb) => thumb.dataset.mediaId === String(selected.featured_media.id))
        : thumbnails.find((thumb) => thumb.dataset.galleryKey === galleryKey);
      if (matchingThumb) selectThumbnail(matchingThumb);
    };

    root.querySelectorAll('[data-variant-selector] input').forEach((input) => input.addEventListener('change', updateVariant));
    updateVariant();
  });

  } catch(e) { console.error(e); }
})();
})();
